import { render, staticRenderFns } from "./company-details.vue?vue&type=template&id=d05cffea&"
import script from "./company-details.vue?vue&type=script&lang=js&"
export * from "./company-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports